module.exports = __webpack_public_path__ + "img/card5hover.930f6b21.svg";